<template>
  <div id="app">
    <!-- :style="{ width: (getTreeMaxCount(tree) * (nodeWidth * 1.5)) + 'px' }" -->
    <div class="tree-title" ref="treeTitle" :style="titleStyle"><img src="./assets/company.png" alt=""></div>
    <div class="link-line" :style="linkLineStyle"></div>
    <div class="tree-container" ref="treeContainer">
      <Tree v-for="tree in trees" :key="tree.id" :source="tree" :nodeWidth="nodeWidth"></Tree>
    </div>
  </div>
</template>

<script>
import Tree from "./components/tree";
// import test from "./test"

export default {
  name: 'App',
  components: {
    Tree
  },
  data() {
    return {
      trees: [],
      screenWidth: 0,
      screenHeight: 0,
      resizeCount: 1,
      nodeWidth: 205,
      linkLine: {},
      title: {}
    }
  },
  mounted() {
    // this.trees = test

    this.$http({
      method: "GET",
      url: "https://mng.htchaxun.cn/call_back/order/l_tree_data"
    }).then(res => {
      this.trees = res.data.data.tree
      
      this.$nextTick(()=>{
        this.initNode()
      })
    })
  },
  computed: {
    linkLineStyle() {
      return {
        top: `${this.linkLine.top}px`,
        left: `${this.linkLine.left}px`,
        // right: `${this.linkLine.right}px`,
        width: `${this.linkLine.width}px`,
        // transform: `rotate(${this.linkLine.angel}deg)`
      }
    },
    titleStyle() {
      return {
        // top: `140px`,
        marginLeft: `${this.title.marginLeft}px`,
        // right: `${this.linkLine.right}px`,
        // width: `${this.linkLine.width}px`,
        // transform: `rotate(${this.linkLine.angel}deg)`
      }
    }
  },
  methods: {
    initNode() {
      const firstEl = this.$refs.treeContainer.firstChild
      const lastEl = this.$refs.treeContainer.lastChild
      const firstElLeft = firstEl.offsetLeft + firstEl.firstChild.offsetLeft + this.nodeWidth / 2
      const lastElLeft = lastEl.offsetLeft + lastEl.firstChild.offsetLeft + this.nodeWidth / 2
      const length = lastElLeft - firstElLeft
      
      this.linkLine = {
        top: this.$refs.treeTitle.offsetTop + this.$refs.treeTitle.offsetHeight + 20 + 4,
        left: firstElLeft,
        width: length
      }

      if(this.trees.length > 1) {
        this.title = {
          marginLeft: firstElLeft + length / 2 - 40 - 40
        }
      }else{
        this.title = {
          marginLeft: firstElLeft - this.$refs.treeTitle.offsetWidth / 2 - 40
        }
      }
      
    },
    convert2TreeArray(tree) {
      const treeArray = [];

      const loopFunction = (array, index) => {
        for (let i = 0; i < array.length; i++) {
          const item = array[i];

          // 当前操作
          if (!treeArray[index]) treeArray[index] = []

          treeArray[index].push(item)

          // 继续向下
          if (item.child.length > 0) {
            loopFunction(item.child, index + 1)
          }
        }

      }

      loopFunction([tree], 0)

      return treeArray
    },
    getTreeMaxCount(tree) {
      let countArray = this.convert2TreeArray(tree).map(item => item.length).sort((a, b) => a - b).reverse()
      let max = countArray[0] + countArray[1] - 1
      console.log(countArray);
      console.log(max);
      return max
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  padding: 40px;
  min-width: 1600px;
  min-height: 100vh;
  background: url("./assets/bg.png") 100% no-repeat;
  background-position: 0 0;
  background-attachment: fixed;
}

.tree-title{
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 183px;
  height: 183px;
  /* border-radius: 80px; */
  /* border: 1px solid red; */
  /* background: linear-gradient(91deg, #D54B53 0%, rgba(255,255,255,0) 23%, rgba(255,255,255,0) 76%, #D54B53 100%); */
  /* text-align: center; */
  position: relative;
}

.tree-title > img{
  width: 100%;
  height: 100%;
}

.tree-title::after{
  box-sizing: border-box;
  content: "";
  display: block;
  width: 1px;
  height: 20px;
  border-left: 2px solid #999999;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -21px;
}

.link-line{
  position: absolute;
  left: 70px;
  /* right: 70px; */
  height: 1px;
  border-top: 2px solid #999999;
}

.tree-container {
  margin-top: 40px;
  display: flex;
}

</style>
